import { EuiSpacer, EuiButton } from '@elastic/eui';
import { OutboundLink } from 'gatsby-plugin-gtag';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  EuiButton,
  OutboundLink,
  BreadCrumbs,
  SEOHelmet,
  React
};